import { Collapse } from 'antd';
import classNames from 'classnames';
import { ExpandDropDownList } from '@/utils/icons';
import s from '@UI/New/CollapsePanel/index.module.css';

const ChatTopCollapsePanel = ({
  children,
  header = '',
  className = '',
  panelKey,
  activePanel,
  setActivePanel,
}) => {
  const isActive = activePanel === panelKey;
  const customExpandIcon = ({ isActive: isPanelActive }) => (
    isPanelActive
      ? <ExpandDropDownList className={classNames(s.customExpandIcon, s.rotate)} />
      : <ExpandDropDownList className={s.customExpandIcon} />
  );

  return (
    <Collapse
      activeKey={isActive ? [panelKey] : []}
      onChange={(keys) => setActivePanel(keys?.length ? panelKey : null)}
      expandIconPosition="end"
      className={classNames(s.collapse, className)}
      expandIcon={customExpandIcon}>
      <Collapse.Panel key={panelKey} header={header}>
        {children}
      </Collapse.Panel>
    </Collapse>
  );
};

export default ChatTopCollapsePanel;
